import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 2L15 9H22L17 15L19 22L12 18L5 22L7 15L2 9H9L12 2Z",
		fill: "currentColor"
	})
});
export default SvgStarFill;
